import styled from "styled-components";
import cx from "classnames";

export default styled.div.attrs({
  className: ({ className }) => cx("material-icons", className)
})`
  ${({ size = 1 }) => `
    font-size: ${size}rem;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/generic/kit/Icon/index.js